import React from 'react'
import styled from 'styled-components'
import { colors, media } from '../styles/vars'
const Container = styled.li`
color:${props => props.selected ? colors.white : 'rgba(255, 255, 255, .4)'};
font-size:4.3rem;
transition:color .2s;
font-weight:700;
display:inline-block;
&:not(:last-child){
    margin-left:10px;
}
&:first-child{
    transform:translate3d(0, -10px, 0) rotate(-30deg);
}
&:nth-child(2){
    transform:translate3d(0, 10px, 0);
}
&:last-child{
    transform:translate3d(0, -10px, 0) rotate(30deg);    
}
transition: transform .2s;

${
    media.desktop`
    font-size:10rem;
    font-weight:400;
    display:block;
    &:not(:last-child){
        margin:0 0 30px;
    }
    &:first-child, &:last-child{
        transform:none;
    }
    &:nth-child(2){
        transform:translate3d(-60px, 0, 0);
    }
    ${props => {
            if (props.isFirst)
                return `
        &:nth-child(2){
            transform:translate3d(0,-28px,0) rotate(-10deg);
        }
        &:last-child{
            transform:translate3d(45px,-63px,0) rotate(-20deg);    
        }
        `
            if (props.isLast) {
                return `
        &:first-child{
         transform:translate3d(139px,65px,0) rotate(26deg)
        }
        &:nth-child(2){
            transform:translate3d(19px,8px,0) rotate(12deg);
        }
        &:last-child{
            transform:none;   
        }
        `
            }
        }}
    `
    }
`
const TimelineItem = (props) => {
    return (
        <Container
            ref={node => this.node = node}
            selected={props.selected}
            isFirst={props.isFirst}
            isLast={props.isLast}
        >
            {props.title}
        </Container>
    )
}

export default TimelineItem;


// WEBPACK FOOTER //
// ./src/components/TimelineItem.jsx